import { useQuery } from '@tanstack/react-query';

import { customerRepository } from '../../repositories/customer-repository';

interface UseFetchCustomerProps {
  documentType: string;
  documentId: string;
}

export const useFetchCustomer = (props: UseFetchCustomerProps) => {
  const validateRecaptchaCustomer = async () => {
    return customerRepository.queryByTypeAndDocument(
      props.documentId,
      props.documentType,
    );
  };

  return useQuery(
    ['customer', props],
    async () => await validateRecaptchaCustomer(),
    {
      enabled: !!props.documentId && !!props.documentType,
    },
  );
};
